import tableRelatedVods from './tableRelatedVoDs';

export default {
  title: 'vods',
  attributeName: 'vods',
  getURL: 'vodcomposeexperiencemulticamfilter',
  getDataPostUrl: 'vodcomposeexperiencemulticamfilter',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'vod',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableRelatedVods,
};
